import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Content>
        <Title>404</Title>
        <Description>페이지를 찾을 수 없습니다</Description>
        <SubDescription>
          요청하신 페이지가 삭제되었거나 주소가 변경되었을 수 있습니다.
        </SubDescription>
        <ButtonGroup>
          <Button onClick={() => navigate(-1)}>이전 페이지</Button>
          <Button onClick={() => navigate("/")} $isSecondary>
            홈으로 가기
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const Content = styled.div`
  text-align: center;
  padding: 2rem;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  width: 90%;
`;

const Title = styled.h1`
  font-size: 6rem;
  color: #27c360;
  margin: 0;
  line-height: 1;
`;

const Description = styled.h2`
  font-size: 1.5rem;
  color: #343a40;
  margin: 1rem 0;
`;

const SubDescription = styled.p`
  color: #6c757d;
  margin-bottom: 2rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

interface ButtonProps {
  $isSecondary?: boolean;
}

const Button = styled.button<ButtonProps>`
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  background-color: ${(props) => (props.$isSecondary ? "#e9ecef" : "#27c360")};
  color: ${(props) => (props.$isSecondary ? "#495057" : "white")};

  &:hover {
    background-color: ${(props) =>
      props.$isSecondary ? "#dee2e6" : "#229a4c"};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export default NotFound;
